export default function(n) {
  var s = String(n).split('.'), t0 = Number(s[0]) == n;
  return (n == 0 || n == 1) || (t0 && n >= 11 && n <= 99) ? 'one' : 'other';
}
